import { LandingPage, type LandingPageProps } from "@components/heimar/LandingPage";
import { PrivacyPolicy, type PrivacyPolicyProps } from "@components/heimar/PrivacyPolicy";
import { TermsOfUse, type TermsOfUseProps } from "@components/heimar/TermsOfUse";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

function boot() {
  const landingEl = document.getElementById("heimar-landing-root");
  if (landingEl) {
    const props: LandingPageProps = JSON.parse(landingEl.dataset.props || "{}");
    createRoot(landingEl).render(
      <StrictMode>
        <LandingPage {...props} />
      </StrictMode>,
    );
    return;
  }

  const privacyEl = document.getElementById("heimar-privacy-root");
  if (privacyEl) {
    const props: PrivacyPolicyProps = JSON.parse(privacyEl.dataset.props || "{}");
    createRoot(privacyEl).render(
      <StrictMode>
        <PrivacyPolicy {...props} />
      </StrictMode>,
    );
    return;
  }

  const termsEl = document.getElementById("heimar-terms-root");
  if (termsEl) {
    const props: TermsOfUseProps = JSON.parse(termsEl.dataset.props || "{}");
    createRoot(termsEl).render(
      <StrictMode>
        <TermsOfUse {...props} />
      </StrictMode>,
    );
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
